/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { useEffect } from "react";
import { cn } from "tailwind-variants";
import { isProduction } from "common/utils/env";
import { readCookie } from "common/utils/cookie";
import { useDtfStore } from "./store";

export default function GangSheetBuilder({ ...restProps }) {
  const dtfStore = useDtfStore();

  function gangSheetBuilder() {
    // @ts-expect-error TS(4111): Property 'gangSheetBuilder' comes from an index si... Remove this comment to see the full error message
    return dtfStore.gangSheetBuilder;
  }

  function gangSheetBuilderShopId() {
    // @ts-expect-error TS(4111): Property 'gangSheetBuilderShopId' comes from an in... Remove this comment to see the full error message
    return dtfStore.gangSheetBuilderShopId;
  }

  function gangSheetBuilderSizes() {
    // @ts-expect-error TS(4111): Property 'gangSheetBuilderSizes' comes from an ind... Remove this comment to see the full error message
    return dtfStore.gangSheetBuilderSizes;
  }

  function builderPayload() {
    const payload = {
      container: "gs-builder",
      // @ts-expect-error TS(2774): This condition will always return true since this ... Remove this comment to see the full error message
      mode: isProduction ? "production" : "development",
      shop_id: gangSheetBuilderShopId(),
      size_id: 3,
      sizes: gangSheetBuilderSizes(),
      settings: {
        nameAndNumber: {
          enabled: true
        }
      }
    };
    const customerId = readCookie("gangsheet_builder_customer_id");
    console.log("[GangSheetBuilder] <", customerId, ">");
    if (customerId) {
      // @ts-expect-error TS(2339): Property 'customer' does not exist on type '{ cont... Remove this comment to see the full error message
      payload.customer = {
        id: customerId
      };
    }
    return payload;
  }

  function setShowGangSheetBuilder(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return dtfStore.setShowGangSheetBuilder(...args);
  }

  function setGeneratedGangSheets(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return dtfStore.setGeneratedGangSheets(...args);
  }

  function addFilesToQueue(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return dtfStore.addFilesToQueue(...args);
  }

  function showBuilder() {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    gangSheetBuilder()
      .open(builderPayload())
      .on("design:created", (gangSheetData: any) => {
        processGangSheet(gangSheetData.data);
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        gangSheetBuilder().close();
        setShowGangSheetBuilder(false);
      })
      .on("closed", () => {
        setShowGangSheetBuilder(false);
      });
  }

  async function processGangSheet(gangSheetData: any) {
    const { designs } = gangSheetData;
    setGeneratedGangSheets(designs);
    const gangSheets = await Promise.all(
      designs.map(async (design: any) => {
        const downloadedGangSheet = await downloadGangSheetPreview(design);
        if (downloadedGangSheet) {
          return new File([downloadedGangSheet], `${design.id}.png`, {
            type: "image/png"
          });
        }
        return null;
      })
    );
    addFilesToQueue({
      files: gangSheets,
      artworkIndex: null,
      existingArtworkId: null
    });
  }

  async function downloadGangSheetPreview(design: any) {
    let downloadedGangSheet = null;
    try {
      const response = await fetch(design.thumbnail_url);
      downloadedGangSheet = await response.blob();
    } catch (error) {
      /* TODO(vue-migration): this.$store and this.$analytics are Vue injected globals; use React equivalent notifier and analytics service */
      // notifier.error({
      //   message: "Failed to download gang sheet preview",
      //   error
      // });
      // analytics.trackError("GangSheetPreviewDownloadError", error);
    }
    return downloadedGangSheet;
  }
  useEffect(() => {
    showBuilder();
  }, []);

  return (
    <div
      {...restProps}
      // @ts-expect-error TS(4111): Property 'className' comes from an index signature... Remove this comment to see the full error message
      className={cn("modal gang-sheet-builder-modal", restProps.className)}
      id="gang-sheet-builder-modal-body"
      data-testid="modal"
    />
  );
}
